// @ts-nocheck
import * as types from '../types';
import PlayerService from '../../services/PlayerService';
import { notification } from 'antd';
import { setPagination } from './pagination';
import { PAGINATION_KEYS } from '../../utils/constants';
import { handleErrorNotification } from '../../utils/render';
import BonusService from '../../services/BonusService';
import { setBonusEngineMonitor } from './bonus';

export const getPlayerSegmentList = params => async dispatch => {
    dispatch(setPagination(PAGINATION_KEYS.playerSegmentation, { isFetching: true }));

    const data = await PlayerService.getPlayerSegments(params);

    if (data?.items) {
        dispatch(setPlayerSegmentList(data.items));
    }

    dispatch(setPagination(PAGINATION_KEYS.playerSegmentation, { isFetching: false }));
};

export const setPlayerSegmentList = payload => ({
    type: types.PLAYER_SEGMENT_LIST_CHANGED,
    payload,
});

export const clearPlayerSegmentList = () => ({
    type: types.PLAYER_SEGMENT_LIST_CLEARED,
});

export const getPlayerSegment = id => async dispatch => {
    const { info, item } = await PlayerService.getPlayerSegment(id);

    if (!info.success) {
        handleErrorNotification(info.errors, 'Fetching item failed! Please try again');
    }

    dispatch(setPlayerSegment(item));
};

export const setPlayerSegment = payload => ({
    type: types.PLAYER_SEGMENT_CURRENT_CHANGED,
    payload,
});

export const clearPlayerSegment = () => ({
    type: types.PLAYER_SEGMENT_CURRENT_CLEARED,
});

export const createPlayerSegment = formData => async dispatch => {
    const { info } = await PlayerService.createPlayerSegment(formData);

    if (!info.success) {
        handleErrorNotification(info.errors, 'Player Segment Create Failed!');
    }

    dispatch(getPlayerSegmentList());

    notification.success({
        message: 'Player Segment Created!',
    });

    return info;
};

export const updatePlayerSegment = (id, formData) => async dispatch => {
    const { info } = await PlayerService.updatePlayerSegment(id, formData);

    if (!info.success) {
        handleErrorNotification(info.errors, 'Player Segment Update Failed!');
    }

    notification.success({
        message: 'Player Segment Updated!',
    });

    dispatch(getPlayerSegmentList());
    dispatch(clearPlayerSegment());

    return info;
};

export const deletePlayerSegment = id => async (dispatch, getState) => {
    const { info } = await PlayerService.deletePlayerSegment(id);

    if (!info.success) {
        handleErrorNotification(info.errors, 'Player Segment Delete Failed!');
    }

    const { list: playerSegments, current } = getState().player.playerSegments;

    const newPlayerSegments = playerSegments.filter(segment => segment.id !== id);
    dispatch(setPlayerSegmentList(newPlayerSegments));

    // remove item from state if it is the one being edited
    if (current?.id === id) {
        dispatch(clearPlayerSegment());
    }

    notification.success({
        message: 'Segment Deleted!',
    });
};

export const getPlayerSegmentReport = params => async (dispatch, getStore) => {
    const store = getStore();
    const { list: currentReport } = store.player.playerSegmentsReport;

    dispatch(setPlayerSegmentReport(params.page > 0 ? currentReport : []));
    dispatch(
        setPagination(PAGINATION_KEYS.playerSegmentationReport, {
            isFetching: true,
        }),
    );

    const { info, items } = await PlayerService.getPlayerSegmentReport(params);

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.playerSegmentationReport, {
                isFetching: false,
            }),
        );
        return;
    }

    let newPlayerSegmentReport = [];

    if (params.page > 0) {
        newPlayerSegmentReport = currentReport.concat(items);
    } else {
        newPlayerSegmentReport = items;
    }

    const hasMore = items.length >= params.page;

    dispatch(setPlayerSegmentReport(newPlayerSegmentReport));

    dispatch(
        setPagination(PAGINATION_KEYS.playerSegmentationReport, {
            page: params.page,
            size: params.size,
            hasMore,
            isFetching: false,
        }),
    );

    return newPlayerSegmentReport;
};

export const setPlayerSegmentReport = payload => ({
    type: types.PLAYER_SEGMENT_REPORT_CHANGED,
    payload,
});

export const clearPlayerSegmentReport = () => ({
    type: types.PLAYER_SEGMENT_REPORT_CLEARED,
});

export const getPlayerDetails = params => async dispatch => {
    const { info, item } = await PlayerService.getPlayerDetails(params);

    if (!info.success) return;

    dispatch(setPlayerDetails(item));
};

export const setPlayerDetails = payload => ({
    type: types.PLAYER_DETAILS_CHANGED,
    payload,
});

export const clearPlayerDetails = () => ({
    type: types.PLAYER_DETAILS_CLEARED,
});

export const getFinancialTransactionsSummary = params => async dispatch => {
    const { info, item } = await PlayerService.getFinancialTransactionsSummary(params);

    if (info.success) {
        dispatch(setFinancialTransactionsSummary(item));
    }
};

export const setFinancialTransactionsSummary = payload => ({
    type: types.PLAYER_FINANCIAL_TRANSACTIONS_SUMMARY_CHANGED,
    payload,
});

export const clearFinancialTransactionsSummary = () => ({
    type: types.PLAYER_FINANCIAL_TRANSACTIONS_SUMMARY_CLEARED,
});

export const getFinancialTransactionsDetailed = params => async dispatch => {
    const { info, items } = await PlayerService.getFinancialTransactionsDetailed(params);

    if (info.success) {
        dispatch(setFinancialTransactionsDetailed(items));
    }
};

export const setFinancialTransactionsDetailed = payload => ({
    type: types.PLAYER_FINANCIAL_TRANSACTIONS_DETAILED_CHANGED,
    payload,
});

export const clearFinancialTransactionsDetailed = () => ({
    type: types.PLAYER_FINANCIAL_TRANSACTIONS_DETAILED_CLEARED,
});

export const getFinancialTransactionsPendingWithdrawals = params => async dispatch => {
    const { info, items } = await PlayerService.getFinancialTransactionsPendingWithdrawals(params);

    if (info.success) {
        dispatch(setFinancialTransactionsPendingWithdrawals(items));
    }
};

export const setFinancialTransactionsPendingWithdrawals = payload => ({
    type: types.PLAYER_FINANCIAL_TRANSACTIONS_PENDING_WITHDRAWALS_CHANGED,
    payload,
});

export const clearFinancialTransactionsPendingWithdrawals = () => ({
    type: types.PLAYER_FINANCIAL_TRANSACTIONS_PENDING_WITHDRAWALS_CLEARED,
});

export const getFinancialTransactionsKPI = params => async dispatch => {
    const { info, item } = await PlayerService.getFinancialTransactionsKPI(params);

    if (info.success) {
        dispatch(setFinancialTransactionsKPI(item));
    }
};

export const setFinancialTransactionsKPI = payload => ({
    type: types.PLAYER_FINANCIAL_TRANSACTIONS_KPI_CHANGED,
    payload,
});

export const clearFinancialTransactionsKPI = () => ({
    type: types.PLAYER_FINANCIAL_TRANSACTIONS_KPI_CLEARED,
});

export const getPlayerProfitsAndLosses = params => async dispatch => {
    const { info, item } = await PlayerService.getProfitsAndLosses(params);

    if (info.success) {
        dispatch(setPlayerProfitsAndLosses(item));
    }
};

export const setPlayerProfitsAndLosses = payload => ({
    type: types.PLAYER_PROFITS_AND_LOSSES_CHANGED,
    payload,
});

export const clearPlayerProfitsAndLosses = () => ({
    type: types.PLAYER_PROFITS_AND_LOSSES_CLEARED,
});

export const updatePlayerVerificationStatuses = data => async dispatch => {
    const { info, item } = await PlayerService.updateVerificationStatuses(data);

    if (info.success) {
        dispatch({
            type: types.PLAYER_VERIFICATION_STATUSES_CHANGED,
            payload: item,
        });

        notification.success({ message: 'Successfully updated!' });
    } else {
        handleErrorNotification(info.errors, 'Update Failed!');
    }

    return { info };
};

export const updatePlayerCommunicationPreferences = data => async dispatch => {
    const { info, item } = await PlayerService.updateCommunicationPreferences(data);

    if (info.success) {
        dispatch({
            type: types.PLAYER_COMMUNICATION_PREFERENCES_CHANGED,
            payload: item,
        });

        notification.success({ message: 'Successfully updated!' });
    } else {
        handleErrorNotification(info.errors, 'Update Failed!');
    }

    return { info };
};

export const getPlayerPaymentAccounts = params => async dispatch => {
    const { info, items } = await PlayerService.getPaymentAccounts(params);

    if (info.success) {
        dispatch(setPlayerPaymentAccounts(items));
    }
};

export const setPlayerPaymentAccounts = payload => ({
    type: types.PLAYER_PAYMENT_ACCOUNTS_CHANGED,
    payload,
});

export const clearPlayerPaymentAccounts = () => ({
    type: types.PLAYER_PAYMENT_ACCOUNTS_CLEARED,
});

export const getPlayerDocuments = params => async dispatch => {
    const { info, items } = await PlayerService.getDocuments(params);

    if (info.success) {
        dispatch(setPlayerDocuments(items));
    }
};

export const setPlayerDocuments = payload => ({
    type: types.PLAYER_DOCUMENTS_CHANGED,
    payload,
});

export const clearPlayerDocuments = () => ({
    type: types.PLAYER_DOCUMENTS_CLEARED,
});

export const updatePlayerDocument =
    ({ accountNumber, ...data }) =>
    async (dispatch, getStore) => {
        const { info, items } = await PlayerService.updateDocument(data);

        if (info.success) {
            const currentDocs = getStore().player.documents;
            const isKycVerificationStatusChanged = (items || []).some(
                updatedItem => currentDocs.find(doc => doc.id === updatedItem.id)?.status !== updatedItem.status,
            );

            await dispatch(getPlayerDocuments({ accountNumber }));

            if (isKycVerificationStatusChanged) {
                dispatch(getPlayerDetails(accountNumber));
            }
        } else {
            handleErrorNotification(info?.errors, 'Document Update Failed!');
        }

        return info;
    };

export const deletePlayerDocument = ({ accountNumber, ...data }) => async (dispatch, getStore) => {
    const { info } = await PlayerService.deleteDocument(data);

    if (info.success) {
        const currentDocs = getStore().player.documents;

        const newDocs = currentDocs.filter(doc => doc.id !== data.id);

        dispatch(setPlayerDocuments(newDocs));
        dispatch(getPlayerDetails(accountNumber));

        return info;
    } else {
        handleErrorNotification(info.errors, 'Document Delete Failed!');
        return info;
    }
};

export const uploadPlayerDocuments = formData => async (dispatch, getStore) => {
    const { info, items } = await PlayerService.uploadDocuments(formData);

    if (info.success) {
        notification.success({ message: 'Documents Uploaded!' });

        const currentDocs = getStore().player.documents;

        dispatch(setPlayerDocuments([...currentDocs, ...items]));
        dispatch(getPlayerDetails(formData.get('accountNumber')));
    } else {
        handleErrorNotification(info.errors, 'Document Update Failed!');
    }

    return info;
};

export const getPlayerMessageThreads = params => async dispatch => {
    const { info, items } = await PlayerService.getMessageThreads(params);

    if (info.success) {
        dispatch(setPlayerMessageThreads(items));
        dispatch(
            changePlayerMessageModalProps({
                shouldRefreshData: false,
            }),
        );
    }
};

export const setPlayerMessageThreads = items => ({
    type: types.PLAYER_MESSAGE_THREAD_LIST_CHANGED,
    payload: items,
});

export const clearPlayerMessageThreads = () => ({
    type: types.PLAYER_MESSAGE_THREAD_LIST_CLEARED,
});

export const getPlayerMessageThreadById = id => async dispatch => {
    const { info, item } = await PlayerService.getMessageThreadById(id);

    if (info.success) {
        dispatch(setPlayerMessageThreadById({ id, data: item }));
    }

    return { info };
};

export const setPlayerMessageThreadById = payload => ({
    type: types.PLAYER_MESSAGE_THREAD_SINGLE_CHANGED,
    payload,
});

export const clearSelectedPlayerMessageThreads = () => ({
    type: types.PLAYER_MESSAGE_THREAD_SINGLE_CLEARED,
});

export const sendMessageToPlayer = data => async dispatch => {
    const { info } = await PlayerService.sendNewMessage(data);

    if (info.success) {
        notification.success({ message: 'Message Sent Successfully!' });
        dispatch(
            changePlayerMessageModalProps({
                isVisible: false,
                viewOnly: false,
                shouldRefreshData: true,
            }),
        );
    } else {
        handleErrorNotification(info.errors, 'Message Not Sent!');
    }

    return { info };
};

export const replyToPlayerMessage = data => async dispatch => {
    const { info } = await PlayerService.replyToMessage(data);

    if (info.success) {
        notification.success({ message: 'Message Sent Successfully!' });

        dispatch(
            changePlayerMessageModalProps({
                isVisible: false,
                viewOnly: false,
                shouldRefreshData: true,
            }),
        );
        dispatch(clearSelectedPlayerNote());
    } else {
        handleErrorNotification(info.errors, 'Message Not Sent!');
    }

    return { info };
};

export const archivePlayerMessage = id => async dispatch => {
    const { info } = await PlayerService.deleteNote(id);

    if (info.success) {
        notification.success({ message: 'Note successfully deleted!' });
        dispatch(
            changePlayerNoteModalProps({
                shouldRefreshData: true,
            }),
        );
    } else {
        handleErrorNotification(info.errors, 'Delete failed!');
    }
};

export const changePlayerMessageModalProps = payload => ({
    type: types.PLAYER_MESSAGE_MODAL_PROPS_CHANGED,
    payload,
});

export const clearPlayerMessageModalProps = () => ({
    type: types.PLAYER_MESSAGE_MODAL_PROPS_CLEARED,
});

export const getPlayerNotes = params => async dispatch => {
    const { info, items } = await PlayerService.getNotes(params);

    if (info.success) {
        dispatch(setPlayerNotes(items));
        dispatch(
            changePlayerNoteModalProps({
                isVisible: false,
                shouldRefreshData: false,
                selectedThreadId: null,
            }),
        );
    }
};

export const setPlayerNotes = items => ({
    type: types.PLAYER_NOTE_LIST_CHANGED,
    payload: items,
});

export const clearPlayerNotes = () => ({
    type: types.PLAYER_NOTE_LIST_CLEARED,
});

export const getPlayerNoteById = (id, viewOnly) => async dispatch => {
    const { info, item } = await PlayerService.getNoteById(id);

    if (info.success) {
        dispatch(setPlayerNoteById(item));
        dispatch(
            changePlayerNoteModalProps({
                isVisible: true,
                viewOnly,
            }),
        );
    }

    return { info };
};

export const setPlayerNoteById = payload => ({
    type: types.PLAYER_NOTE_SINGLE_CHANGED,
    payload,
});

export const createPlayerNote = data => async dispatch => {
    const { info } = await PlayerService.createNote(data);

    if (info.success) {
        notification.success({ message: 'New Note Created!' });
        dispatch(
            changePlayerNoteModalProps({
                isVisible: false,
                viewOnly: false,
                shouldRefreshData: true,
            }),
        );
    } else {
        handleErrorNotification(info.errors, 'Note Create Failed!');
    }

    return { info };
};

export const updatePlayerNote = data => async dispatch => {
    const { info } = await PlayerService.updateNote(data);

    if (info.success) {
        notification.success({ message: 'Note Updated!' });

        dispatch(
            changePlayerNoteModalProps({
                isVisible: false,
                viewOnly: false,
                shouldRefreshData: true,
            }),
        );
        dispatch(clearSelectedPlayerNote());
    } else {
        handleErrorNotification(info.errors, 'Note Update Failed!');
    }

    return { info };
};

export const deletePlayerNote = id => async dispatch => {
    const { info } = await PlayerService.deleteNote(id);

    if (info.success) {
        notification.success({ message: 'Note successfully deleted!' });
        dispatch(
            changePlayerNoteModalProps({
                shouldRefreshData: true,
            }),
        );
    } else {
        handleErrorNotification(info.errors, 'Delete failed!');
    }
};

export const clearSelectedPlayerNote = () => ({
    type: types.PLAYER_NOTE_SINGLE_CLEARED,
});

export const changePlayerNoteModalProps = payload => ({
    type: types.PLAYER_NOTE_MODAL_PROPS_CHANGED,
    payload,
});

export const clearPlayerNoteModalProps = () => ({
    type: types.PLAYER_NOTE_MODAL_PROPS_CLEARED,
});

export const changePlayerPasswordModalProps = payload => ({
    type: types.PLAYER_PASSWORD_MODAL_PROPS_CHANGED,
    payload,
});

export const clearPlayerPasswordModalProps = () => ({
    type: types.PLAYER_PASSWORD_MODAL_PROPS_CLEARED,
});

export const changePlayerInformationModalProps = payload => ({
    type: types.PLAYER_INFORMATION_MODAL_PROPS_CHANGED,
    payload,
});

export const clearPlayerInformationModalProps = () => ({
    type: types.PLAYER_INFORMATION_MODAL_PROPS_CLEARED,
});

export const changePlayerManualPaymentModalProps = payload => ({
    type: types.PLAYER_MANUAL_PAYMENT_MODAL_PROPS_CHANGED,
    payload,
});

export const returnToAutomaticSegment = accountNumber => async dispatch => {
    const { info, item } = await PlayerService.returnToAutomaticSegment({ accountNumber });

    if (info.success) {
        dispatch({
            type: types.PLAYER_AUTOMATIC_SEGMENT_RETURNED,
            payload: item?.name ?? null,
        });

        notification.success({ message: 'Player returned to automatic segmentation!' });
    } else {
        handleErrorNotification(info.errors, 'Failed to return to automatic segmentation!');
    }

    return { info };
};

export const clearPlayerManualPaymentModalProps = () => ({
    type: types.PLAYER_MANUAL_PAYMENT_MODAL_PROPS_CLEARED,
});

export const updatePlayerInformation = data => async dispatch => {
    const { info } = await PlayerService.updatePlayerInformation(data);

    if (info.success) {
        dispatch(getPlayerDetails(data.accountNumber));
    }

    return { info };
};

export const updatePlayerBalance = data => async dispatch => {
    const { info } = await PlayerService.updatePlayerBalance(data);

    if (info.success) {
        notification.success({ message: 'Balance successfully updated!' });
        dispatch(getPlayerDetails(data.accountNumber));
    } else {
        handleErrorNotification(info.errors, 'Balance update failed!');
    }

    return { info };
};

export const changePlayerFrozenStatus = data => async dispatch => {
    const { info } = await PlayerService.changeFrozenStatus(data);

    if (info.success) {
        notification.success({ message: 'Balance successfully updated!' });
        dispatch(getPlayerDetails(data.accountNumber));
    } else {
        handleErrorNotification(info.errors, 'Balance update failed!');
    }

    return { info };
};

export const createDepositLimit = params => async dispatch => {
    const { info } = await PlayerService.createDepositLimit(params);

    if (!info.success) return;

    dispatch(getDepositLimit(params.accountNumber));
};

export const getDepositLimit = params => async dispatch => {
    const { info, items } = await PlayerService.getDepositLimit(params);

    if (!info.success) return;

    dispatch(setDepositLimits(items));
};

export const deleteDepositLimit = accountNumber => async dispatch => {
    const { info } = await PlayerService.deleteDepositLimit(accountNumber);

    if (!info.success) return;

    dispatch(getDepositLimit(accountNumber));
};

export const getSelfExclusions = params => async dispatch => {
    const { info, item } = await PlayerService.getSelfExclusions(params);

    if (!info.success) return;

    dispatch(setSelfExclusions(item));
};

export const selfExclude = params => async dispatch => {
    const { info, item } = await PlayerService.selfExclusion(params);

    if (info.success) {
        dispatch(setSelfExclusions(item));
    }

    return info;
};

export const setSelfExclusions = payload => ({
    type: types.PLAYER_SELF_EXCLUSION_CHANGED,
    payload,
});

export const setDepositLimits = payload => ({
    type: types.PLAYER_DEPOSIT_LIMITS_CHANGED,
    payload,
});

export const removePlayerTag = (actionType, data) => async (dispatch, getStore) => {
    const { info } = await PlayerService.massUpdatePlayers(actionType, data);

    if (info.success) {
        notification.success({ message: 'Tag successfully removed' });

        const { playerDetails } = getStore().player;
        const newTags = playerDetails.tags
            .split(',')
            .filter(item => item !== data.tags[0])
            .join(',');

        dispatch(
            setPlayerDetails({
                ...playerDetails,
                tags: newTags,
            }),
        );
    } else {
        handleErrorNotification(info.errors, 'Tag removal failed!');
    }
};

export const clearGiveBonusModalProps = () => ({
    type: types.PLAYER_GIVE_BONUS_MODAL_PROPS_CLEARED,
});

export const changeGiveBonusModalProps = payload => ({
    type: types.PLAYER_GIVE_BONUS_MODAL_PROPS_CHANGED,
    payload,
});

export const changeSegmentNameFilter = payload => ({
    type: types.PLAYER_SEGMENT_NAME_FILTER_CHANGED,
    payload,
});

export const changeManualSegmentModalProps = payload => ({
    type: types.PLAYER_MANUAL_SEGMENT_MODAL_PROPS_CHANGED,
    payload,
});

export const clearManualSegmentModalProps = () => ({
    type: types.PLAYER_MANUAL_SEGMENT_MODAL_PROPS_CLEARED,
});

export const updateDocumentNumber = data => async dispatch => {
    const { info } = await PlayerService.updateDocumentNumber(data);

    if (info.success) {
        notification.success({ message: 'Document Number successfully updated!' });
        dispatch(getPlayerDetails(data.accountNumber));
    } else {
        notification.error({ message: 'Something went wrong' });
    }

    return { info };
};
